export default [
  {
    imgSrc: "/img/user_man.png",
    imgAlt: "Plombier pas cher Toulouse",
    username: "Vincent Van S.",
    rating: "⭐⭐⭐⭐⭐",
    text: `Changement de chauffe-eau. Un travail impeccable, le plombier était sympa, et le devis tout à fait correct. Recommandé !!`
  },
  {
    imgSrc: "/img/user_man.png",
    imgAlt: "Plombier à Toulouse",
    username: "Alain V.",
    rating: "⭐⭐⭐⭐⭐",
    text: `Rapidité. Politesse..Gentillesse Très bien.. Prix normal. Bravo`
  },
  {
    imgSrc: "/img/user_woman.png",
    imgAlt: "Fuite Cumulus",
    username: "Sarah D.",
    rating: "⭐⭐⭐⭐⭐",
    text: `L’intervention s’est très bien passée, Thierry très efficace, et respectueux de laisser l’appartement propre en nettoyant après [...]`
  }
];
